import React from "react";
import "./Onas.css";
import { useTranslation } from "react-i18next";

const Onas = () => {
  const { t } = useTranslation();

  return (
    <div className="onascelkontejner">
      <div className="onassimplelayoutcontainer">
        <div className="onastextcontainer">
          <h2>{t('onas_title')}</h2>
          <p>{t('onas_purpose')}</p>
          <h2>{t('onas_questions_title')}</h2>
          <p>{t('onas_test_desc')}</p>
          <p>{t('onas_test_prompt')}</p>
          <p>{t('onas_q1')}</p>
          <p>{t('onas_q2')}</p>
          <p>{t('onas_q3')}</p>
          <p>{t('onas_q4')}</p>
        </div>
      </div>
    </div>
  );
};

export default Onas;